// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_e638852","successModal":"_2b87a0f","container":"_2f01f38","imageContainer":"_81f8273","tick":"_4b456e0","content":"_e962f10","button":"_1967dd6"};